import React from 'react';

type SvgProps = {
    color?: string;
    size?: number;
};

const AktiverVerkehrIcon: React.FC<SvgProps> = ({ color = "white", size = 24 }) => (
    <svg width={size} height={size} viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M74 140C43.58 137 20 111.26 20 80C20 48.74 43.58 23 74 20V140ZM86.1784 20V73.94H139.998C137.178 45.5 114.558 22.82 86.1784 20ZM86.1784 139.995V86.0547H139.998C137.178 114.495 114.618 137.175 86.1784 139.995Z" fill={color} fillOpacity="0.8" />
    </svg>

);

export default AktiverVerkehrIcon;
